import { useMutation } from '@tanstack/react-query';
import API from 'api/API';

export const useValidateTrayReference = () => {
  const mutation = useMutation(async ({ deliveryId, trayReference }: { deliveryId: string; trayReference: number }) => {
    return await API.deliveries.validateTrayReference(deliveryId, trayReference);
  });

  return mutation;
};
